import React from 'react';
import { TouchableHighlight } from 'react-native';
import { Surface } from 'react-native-paper';
import styled from 'styled-components/native';

import Image from '@src/components/Image';
import ImageBackground from '@src/components/ImageBackground';
import { H3 } from '@src/components/Typography';
import {
  journeyCardHeight,
  journeyCardWidth,
} from '@src/configuration/constants';
import useProfile from '@src/hooks/useProfile';

type Props = {};

const Container = styled(Surface)`
  border-radius: ${({ theme }) => theme.roundness}px;
  background-color: ${({ theme }) => theme.colors.placeholder};
  overflow: hidden;
  elevation: 4;
`;

const Cover = styled(ImageBackground).attrs({
  resizeMode: 'cover',
})`
  background-color: ${({ theme }) => theme.colors.placeholder};
  width: ${journeyCardWidth}px;
  height: ${journeyCardHeight}px;
  align-items: center;
  justify-content: center;
`;

const Avatar = styled(Image).attrs({
  resizeMode: 'cover',
})`
  width: ${journeyCardHeight / 2}px;
  height: ${journeyCardHeight / 2}px;
  border-radius: ${journeyCardHeight / 4}px;
  border-width: 3px;
  border-color: ${({ theme }) => theme.colors.primary};
  background-color: ${({ theme }) => theme.colors.placeholder};
  position: absolute;
  top: 20px;
`;

const Title = styled(H3).attrs({
  numberOfLines: 1,
  ellipsizeMode: 'tail',
})`
  margin-left: 10px;
  margin-right: 10px;
  color: #ffffff;
  position: absolute;
  bottom: 4px;
  left: 0;
  right: 0;
  text-align: center;
`;

const Component: React.FC<Props> = () => {
  const profile = useProfile();
  const handlePress = () => {
    console.log('route to create a journey!');
  };

  const avatarSource =
    profile?.avatar || require('@src/assets/images/avatar.png');
  return (
    <Container>
      <TouchableHighlight onPress={handlePress}>
        <Cover source={require('@src/assets/images/tourPlaceholder.png')}>
          <Avatar source={avatarSource} />
          <Title>Create a new journey</Title>
        </Cover>
      </TouchableHighlight>
    </Container>
  );
};

Component.displayName = 'EmptyJourneyCard';

export default React.memo(Component);
